export default __webpack_public_path__ + "static/media/valueAdded.28ca855b.svg";